var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 11.9609L18.3438 7.78125C18.5781 7.54688 18.5781 7.11719 18.3438 6.88281L17.3672 5.90625C17.1328 5.67188 16.7031 5.67188 16.4688 5.90625L12.2891 10.125L8.07031 5.90625C7.83594 5.67188 7.40625 5.67188 7.17188 5.90625L6.19531 6.88281C5.96094 7.11719 5.96094 7.54688 6.19531 7.78125L10.4141 11.9609L6.19531 16.1797C5.96094 16.4141 5.96094 16.8438 6.19531 17.0781L7.17188 18.0547C7.40625 18.2891 7.83594 18.2891 8.07031 18.0547L12.2891 13.8359L16.4688 18.0547C16.7031 18.2891 17.1328 18.2891 17.3672 18.0547L18.3438 17.0781C18.5781 16.8438 18.5781 16.4141 18.3438 16.1797L14.125 11.9609Z",
    fill: "#00095B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a34d4a4d4d748cc125975d9cdf085b8e.svg";
export { ForwardRef as ReactComponent };